export default function (pointA, pointB) {
  return pointA[0] === pointB[0] && pointA[1] === pointB[1];
}